
export default {
  name: 'CategoryFilter',
  components: {},
  props: {
    leadTimeList: {
      type: Array,
      default: () => {
        return []
      },
    },
    colourList: {
      type: Array,
      default: () => {
        return []
      },
    },
    collectionsList: {
      type: Array,
      default: () => {
        return []
      },
    },
    featureList: {
      type: Array,
      default: () => {
        return []
      },
    },
    decorationList: {
      type: Array,
      default: () => {
        return []
      },
    },
    complianceList: {
      type: Array,
      default: () => {
        return []
      },
    },
    priceRange1: {
      type: Number,
      default: 1,
    },
    priceRange2: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8'],
      priceList: [],
      marks: {
        1: '1',
        25: '25',
        50: '50',
        100: '100',
        250: '250',
        500: '500',
        1000: '1000+',
      },
      // 滑块绑定的是quantity, 输入框绑定的是quantity2. 要将两者分开, 且拖动滑块时同时更新quantity2, 需要中间变量用来判断当前是哪个组件在变更值
      quantityFlag: 1,
      quantity: 1000,
      quantity2: 1000,
      priceRange: [1, 10000],
      marksForPrice: {},
      checkedLeadtime: '',
      checkedColor: [],
      checkedDecoraiton: [],
      checkedFeature: [],
      checkedCollection: [],
      checkedCompliance: [],
      showallOfColor: false,
      showallOfFeature: false,
      showallOfCollection: false,
      showallOfDecoration: false,
      showallOfCompliance: false,
    }
  },
  computed: {},
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.query.lead_time) {
          const temp = Number(to.query.lead_time)
          if ([1, 2, 3, 4, 5, 6, 7].includes(temp)) {
            this.checkedLeadtime = typeof temp === 'number' ? temp : ''
          }
        } else {
          this.checkedLeadtime = ''
        }

        if (to.query.qty) {
          const qty = Number(to.query.qty)
          if (typeof qty === 'number') {
            this.quantity = qty
            this.quantity2 = qty
          }
        } else {
          this.quantity = 1000
          this.quantity2 = 1000
        }
        if (to.query.feature) {
          this.checkedFeature = [Number(to.query.feature)]
        } else {
          this.checkedFeature = []
        }
      },
    },
    priceRange1() {
      this.priceRange[0] = this.priceRange1
    },
    priceRange2() {
      this.priceRange[1] = this.priceRange2
    },
  },
  created() {},
  beforeMount() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    // 滑块组件实时变动时的响应逻辑
    handleInputQuantity1(value) {
      if (this.quantityFlag === 1) {
        this.quantity2 = value
      }
    },
    // 滑块组件变动后(鼠标按键放起)的响应逻辑
    handleChangeQuantity(value) {
      if (value) {
        this.quantity = value
      } else {
        this.quantity = 1
      }
      this.$emit('handleChangeQuantity', value)
    },
    handleInputQuantity2(e) {
      this.quantityFlag = 2
      if (!e) {
        this.quantity = 1
      } else {
        this.quantity = Number(this.quantity2)
        this.quantity2 = Number(this.quantity2)
      }
      this.$nextTick(() => {
        this.$emit('handleChangeQuantity', Number(e.target?.value || 1))
      })

      setTimeout(() => {
        this.quantityFlag = 1
      }, 2000)
    },
    handleChangePrice(value) {
      this.$emit('handleChangePrice', this.priceRange)
    },
    handleInputPrice(isInput=true) {
      if (this.priceRange[1] > 10000) {
        const min = this.priceRange[0]
        this.priceRange = [min, 10000]
      }

      if (this.priceRange[0] > this.priceRange[1]) {
        this.priceRange[1] = this.priceRange[0]
      }
      // 输入框数值触发el-slider视图
      if(isInput){
        this.$refs.sliderRef._data.firstValue = this.priceRange[0];
        this.$refs.sliderRef._data.secondValue = this.priceRange[1];
      }

      this.handleChangePrice();
    },
    handleChangeLeadtime() {
      this.$emit('handleChangeLeadtime', this.checkedLeadtime)
    },
    handleChangeFeature() {
      this.$emit('handleChangeFeature', this.checkedFeature)
    },
    clearFeature() {
      this.checkedFeature = []
      this.handleChangeFeature()
    },
    handleChangeColor() {
      this.$emit('handleChangeColor', this.checkedColor)
    },
    clearColor() {
      this.checkedColor = []
      this.handleChangeColor()
    },
    handleChangeCollection() {
      this.$emit('handleChangeCollection', this.checkedCollection)
    },
    clearCollection() {
      this.checkedCollection = []
      this.handleChangeCollection()
    },
    handleChangeCompliance() {
      this.$emit('handleChangeCompliance', this.checkedCompliance)
    },
    clearCompliance() {
      this.checkedCompliance = []
      this.handleChangeCompliance()
    },
    handleChangeDecoration() {
      this.$emit('handleChangeDecoration', this.checkedDecoraiton)
    },
    resetFilter() {
      if (!this.$route.query.qty) {
        this.quantity = 1000
        this.quantity2 = 1000
      }
      this.priceRange = [this.priceRange1, this.priceRange2]
      this.checkedCollection = []
      this.checkedCompliance = []
      this.checkedLeadtime = ''
      this.checkedColor = []
      this.checkedDecoraiton = []
      this.checkedFeature = []
      this.$emit('reset')
    },
  },
}
